import { Color } from "@starrez/starryui";
import styled from "styled-components";

export const TemplateSelectionContainerDiv = styled.div`
    display: flex;
    flex: 1;
    flex-direction: row;
    width: 100%;
    max-height: 100%;
    overflow: hidden;
`;

export const DirectoryTreeviewContainerDiv = styled.div`
    border-right: 1px solid ${Color.Grey.G20};
    height: 100%;
    padding: 5px 5px 5px 12px;
    position: relative;
    overflow: auto;
    white-space: nowrap;
    width: 300px;
`;

export const TemplateGridDiv = styled.div`
    padding: 16px;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    height: 100%;
`;

export const TemplateGridHeaderDiv = styled.div`
    margin-bottom: 16px;
`;

export const TemplateGridHeaderH2 = styled.div`
    color: ${Color.Grey.G80};
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 0.02em;
`;

export const TemplateGridEmptyContainerDiv = styled.div`
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
`;
